import get from 'lodash.get';

const getSupportedLocales = (rootState) =>
  get(rootState, 'ws.config.service.common.ws_language_codes.base', []).filter(
    // it's temporary hotfix to exclude ru locale, because it is not longer supported by template
    // we should update ws_language_codes.base value in config and then cleanup this fix
    (locale) => locale !== 'ru'
  );

export default getSupportedLocales;
